import React from 'react';
import { Link } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { useContent } from './contentContext';
import { topicIcon } from './topicIcons';
import './learn.scss';

const LearnHome = () => {
  const { topics, loading, error } = useContent();

  if (loading) return <Typography>Loading…</Typography>;
  if (error) return <Typography color="error">Failed to load content: {error}</Typography>;

  const withContent = topics.filter((t) => t.count > 0);

  return (
    <div className="learn-home">
      <Typography variant="h4" component="h1" gutterBottom>
        Knowledge Base
      </Typography>
      <Typography variant="body1" gutterBottom>
        Concepts with live examples and copyable code — pick a topic.
      </Typography>
      <div className="topic-list">
        {withContent.map((topic) => {
          const Icon = topicIcon(topic.icon);
          return (
            <Card className="topic-card" key={topic.id}>
              <CardActionArea component={Link} to={`/learn/${topic.id}`}>
                <CardContent className="topic-card-content">
                  <Icon className="topic-card-icon" fontSize="large" color="primary" />
                  <Typography variant="h6" component="h2">
                    {topic.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {topic.count} concept{topic.count === 1 ? '' : 's'}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default LearnHome;
